import { call, put } from 'redux-saga/effects';
import * as dayjs from 'dayjs';
import * as actions from '../actions/survey';
import { get, post, axiosPut } from '../../utils/api';
import { errorModalOpen } from '../../utils/functions';

export function* surveyList() {
  try {
    const response = yield call(get, '/survey/list/active');
    yield put(actions.surveyListSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.surveyListFail());
  }
}

export function* saveSurveyResult({ payload }) {
  try {
    yield call(post, '/survey/result/save', payload);
    yield put(actions.saveSurveyResultSuccess());
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.saveSurveyResultFail());
  }
}

export function* getListSurveys({ payload }) {
  const currDate = new Date();
  const dateTo = dayjs(currDate.setDate(currDate.getDate() + 30))
    .format('YYYY-MM-DD');
  const dateFrom = dayjs(currDate.setDate(currDate.getDate() - 90))
    .format('YYYY-MM-DD');
  try {
    const response = yield call(get,
      `/survey/list?dateFrom=${payload.dateFrom !== '' && payload.dateFrom !== null
        ? payload.dateFrom
        : dateFrom}&dateTo=${payload.dateTo !== '' && payload.dateTo !== null
        ? payload.dateTo
        : dateTo}`);
    yield put(actions.getListSurveysSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getListSurveysFail());
  }
}

export function* getSurveyResult({ payload }) {
  try {
    const response = yield call(get, `/survey/result/${payload.surveyNumId}`);
    yield put(actions.getSurveyResultSuccess(response));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.getSurveyResultFail());
  }
}

export function* addSurvey({ payload }) {
  try {
    const response = yield call(post, '/survey/create', payload);
    yield put(actions.addSurveySuccess(response));
    yield put(actions.getListSurveys({
      dateFrom: payload.dateFromFilter,
      dateTo: payload.dateToFilter
    }));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.addSurveyFail());
  }
}

export function* toggleActivationSurvey({ payload }) {
  try {
    const response = yield call(axiosPut, `/survey/toggle_activation/${payload.surveyNumId}`);
    yield put(actions.toggleActivationSurveySuccess(response));
    yield put(actions.getListSurveys({
      dateFrom: payload.dateFrom || '',
      dateTo: payload.dateTo || ''
    }));
  } catch (error) {
    yield put(errorModalOpen(error));
    yield put(actions.toggleActivationSurveyFail());
  }
}
